import type { ReactNode } from 'react'

import { formatDate } from '@/lib/date/date'
import { cn } from '@/lib/ui/style-helpers'

import { AuthorLine } from '@/components/lemmala-design-system/author-line/author-line'

type CommentProps = {
  authorName: string
  authorAvatar?: string
  // Replaces the avatar, e.g. with a blank slot while the author is still resolving.
  avatar?: ReactNode
  createdAt: Date
  children: ReactNode
  actions?: ReactNode
  editedLabel?: string
  anchorId?: string
  highlighted?: boolean
}

export const Comment = ({
  authorName,
  authorAvatar,
  avatar,
  createdAt,
  children,
  actions,
  editedLabel,
  anchorId,
  highlighted,
}: CommentProps) => (
  <div
    id={anchorId}
    className={cn(
      'group flex flex-col gap-1.5 rounded transition-colors',
      highlighted && 'bg-main-background-muted',
    )}
  >
    <AuthorLine
      name={authorName}
      avatarUrl={authorAvatar}
      avatar={avatar}
      date={formatDate(createdAt, 'dateTime')}
      dateTitle={formatDate(createdAt, 'longDate')}
    >
      {editedLabel && (
        <span className='shrink-0 text-main-foreground-tertiary text-body-small'>
          {editedLabel}
        </span>
      )}
      {actions && (
        <div className='ml-auto shrink-0 opacity-0 transition-opacity group-hover:opacity-100 has-[[data-state=open]]:opacity-100'>
          {actions}
        </div>
      )}
    </AuthorLine>
    <div className='pl-8'>{children}</div>
  </div>
)
